import { useMemo, type ReactElement } from "react";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { createCmtsRuntimeRouter } from "@modules/routes.js";
import { cmtsStore } from "@store/index.js";
import { AppErrorBoundary } from "@modules/components/errors/index.js";
import { CmtsAppProviders } from "./appProviders.js";
import { createCmtsHostRuntime, type CmtsHostRuntime } from "./appRuntime.js";

export type CmtsAppProps = {
  runtime?: CmtsHostRuntime | undefined;
};

/**
 * The single public CMTS application entry. All hosts use the canonical data router.
 */
export function App(props: CmtsAppProps): ReactElement {
  const runtime = useMemo(() => props.runtime ?? createCmtsHostRuntime(), [props.runtime]);
  const router = useMemo(() => createCmtsRuntimeRouter(runtime), [runtime]);
  return (
    <Provider store={cmtsStore}>
      <CmtsAppProviders runtime={runtime}>
        <AppErrorBoundary>
          <RouterProvider router={router} />
        </AppErrorBoundary>
      </CmtsAppProviders>
    </Provider>
  );
}

/** @deprecated Use App. Retained only as a source-compatible export during host migration. */
export const CmtsEnterpriseApp = App;
